module.exports = __webpack_public_path__ + "img/satellite3.8a760361.png";